import {FinancialInformation} from "@/store/modules/financialInforamation/types";

export default {
  setFinancialInformation(_state: any, data: FinancialInformation) {
    _state.financialInformation = data;
  }
};
